export default [

     {
          path: '/national-risk-vulnerability',
          name: 'NationalRiskVulnerability',
          component: () => import("@/views/Page/NationalRiskVulnerability/NationalRiskVulnerability.vue"),
          meta: {
               title: 'National Risk Vulnerability',
          },
     }
];